export const getSearchKey = ({query}) => `query:${query}`;
